<template>
  <div class="change-category-path">
    <div class="category-text-wrapper">
      <div class="category-text" :class="oldCategory.cashflowCategory">מ{{ oldCategory.pluralLabel }}</div>
      <div class="category-text" :class="newCategory.cashflowCategory">ל{{ newCategory.pluralLabel }}</div>
    </div>
    <div class="category-path">
      <div class="circle" :class="oldCategory.cashflowCategory"></div>
      <div class="gradient-line" :class="[`right-${oldCategory.cashflowCategory}`, `left-${newCategory.cashflowCategory}`]"></div>
      <div class="left-arrow fa fa-caret-left" :class="newCategory.cashflowCategory"></div>
      <div class="circle" :class="newCategory.cashflowCategory"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ChangeCategoryPath',
  props: {
    oldCategory: {
      required: false,
      type: Object,
    },
    newCategory: {
      required: false,
      type: Object,
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../scss/category-color-mixins';

  .change-category-path {
    direction: rtl;

    .category-text-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 4px;

      .category-text {
        font-size: 16px;
        font-family: SimplerPro;
        font-weight: bold;

        @include category-color;
      }
    }

    .category-path {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .gradient-line {
        height: 1px;
        width: 85%;

        &.right-recurring {
          &.left-variable {
            background: linear-gradient(to left, $riseup_light_blue, $riseup_mustard),
          }

          &.left-recurring {
            background: linear-gradient(to left, $riseup_light_blue, $riseup_light_blue),
          }

          &.left-tracking {
            background: linear-gradient(to left, $riseup_light_blue, $riseup_light_blue),
          }
        }

        &.right-tracking {
          &.left-variable {
            background: linear-gradient(to left, $riseup_light_blue, $riseup_mustard),
          }

          &.left-recurring {
            background: linear-gradient(to left, $riseup_light_blue, $riseup_light_blue),
          }

          &.left-tracking {
            background: linear-gradient(to left, $riseup_light_blue, $riseup_light_blue),
          }
        }

        &.right-variable {
          &.left-recurring {
            background: linear-gradient(to left, $riseup_mustard, $riseup_light_blue),
          }

          &.left-tracking {
            background: linear-gradient(to left, $riseup_mustard, $riseup_light_blue),
          }

          &.left-variable {
            background: linear-gradient(to left, $riseup_mustard, $riseup_mustard),
          }

          &.left-fixed {
            background: linear-gradient(to left, $riseup_mustard, $riseup_coral),
          }

          &.left-excluded-expense {
            background: linear-gradient(to left, $riseup_mustard, $riseup_gray_1),
          }
        }

        &.right-fixed {
          &.left-recurring {
            background: linear-gradient(to left, $riseup_coral, $riseup_light_blue),
          }

          &.left-tracking {
            background: linear-gradient(to left, $riseup_coral, $riseup_light_blue),
          }

          &.left-variable {
            background: linear-gradient(to left, $riseup_coral, $riseup_mustard),
          }

          &.left-fixed {
            background: linear-gradient(to left, $riseup_coral, $riseup_coral),
          }
        }

        &.right-variable-income {
          &.left-fixed-income {
            background: linear-gradient(to left, $riseup_green, $riseup_green),
          }

          &.left-excluded-income {
            background: linear-gradient(to left, $riseup_green, $riseup_gray_1),
          }
        }

        &.right-excluded-expense {
          &.left-variable {
            background: linear-gradient(to left, $riseup_gray_1, $riseup_mustard),
          }
        }

        &.right-excluded-income {
          &.left-variable-income {
            background: linear-gradient(to left, $riseup_gray_1, $riseup_green),
          }
        }

      }

      .left-arrow {
        color: $riseup_mustard;
        transform: scale(1.5,1);
        margin-left: 1px;

        @include category-color;
      }

      .circle {
        width: 16px;
        height: 16px;
        border-radius: 50%;

        @include category-background-color;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-transaction/ChangeCategoryPath.vue